import { DisplayBillState, SimpleInvoice, useRepositoryQuery } from '@mews-commander/data-access';

export const useGetInvoices = (invoiceIds: string[]) => {
    const { data } = useRepositoryQuery(
        'invoices',
        'getAll',
        {
            invoiceIds,
        },
        {
            enabled: !!invoiceIds.length,
            select: (d) =>
                d?.invoices?.map((invoice) => ({
                    invoiceId: invoice.id,
                    ownerId: invoice.ownerId,
                    state: invoice.invoicePaymentState as unknown as DisplayBillState,
                    balance: invoice.balance,
                    ownerName: invoice.ownerName,
                    dueDateLocal: invoice?.dueUtc || '',
                    invoiceNumber: invoice?.number || '',
                })) as SimpleInvoice[],
        }
    );

    return {
        invoices: data,
    };
};
